import React from "react";

export const PauseIconBold = ({...props}) => {
  return (
    <>
      <path d="M18.9602497,24 C20.6132511,24 21.9532349,22.6600162 21.9532349,21.0070148 L21.9532349,3.04910333 C21.9532349,1.39610192 20.612627,0 18.9602497,0 L16.9649262,0 C15.3119257,0 13.971941,1.33998382 13.971941,2.93686715 L13.971941,20.8947786 C13.971941,22.54778 15.3119257,23.8877638 16.9649262,23.8877638 L18.9602497,24 Z M6.98830873,24 C8.64131015,24 9.98129492,22.6600162 9.98129492,21.0070148 L9.98129492,3.04910333 C9.98129492,1.39610192 8.64068695,0 6.98830968,0 L4.99298524,0 C3.33998478,0 2,1.33998382 2,2.99298524 L2,20.9508967 C2,22.659392 3.33998478,24 4.99298524,24 L6.98830873,24 Z"></path>
    </>
  );
};
